import { render } from "./IconPlusCircle.vue?vue&type=template&id=281a8383"
import script from "./IconPlusCircle.vue?vue&type=script&lang=js"
export * from "./IconPlusCircle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__